module.exports = __webpack_public_path__ + "img/hcdl_gallery6.e37103d2.jpg";